/**
 * vue-cesium - https://github.com/zouyaoji/vue-cesium
 * Vue 2.x components for CesiumJS.
 *
 * @package VueCesium
 * @author zouyaoji <370681295@qq.com>
 * @version 2.0.6
 * @license MIT
 * @homepage https://zouyaoji.top/vue-cesium
 * @copyright (c) 2018-2020, zouyaoji <370681295@qq.com>
 */
import mixinMeasure from '../../mixins/tool/mixinMeasure';
import { makeCartesian3Array } from '../../utils/util';

//
var script = {
  name: 'vc-measure-distance',
  mixins: [mixinMeasure],
  data: function data() {
    return {
      type: 'distanceMeasuring',
      measuring: false,
      polylines: []
    };
  },
  props: {
    arcType: {
      type: Number,
      default: 1
    }
  },
  methods: {
    ready: function ready(val) {
      var polylines = this.polylines;
      var polyline = polylines[polylines.length - 1];
      val.cesiumObject.positions = new Cesium.CallbackProperty(function () {
        return makeCartesian3Array(polyline.positions);
      }, false);
    },

    /**
     * 根据传入坐标数组计算距离。
     * @param {Array.Cartesian3} positions 传入的坐标数组
     * @returns {Number} 返回长度数值。
     */
    getDistance: function getDistance(positions) {
      var _Cesium = Cesium,
          Cartesian3 = _Cesium.Cartesian3;
      var distance = 0;

      for (var i = 0; i < positions.length - 1; i++) {
        var s = 0;

        if (this.arcType === 0) {
          s = Cartesian3.distance(positions[i], positions[i + 1]);
        } else {
          // Cartesian.distance gives the straight line distance between the two points, ignoring curvature. This is not what we want.
          // Cartesian3.distance 计算的是两点之间的直线距离，忽略了地球曲率，不太合理。
          // 2.0.3 版本增加测地线距离（GeodesicDistance）。
          s = this.getGeodesicDistance(positions[i], positions[i + 1]);
        }

        distance = distance + s;
      }

      return distance;
    },

    /**
     * 返回两点之间的测地距离。
     * @param {Cartesian3} pointOne 第一个坐标点
     * @param {Cartesian3} pointTwo 第二个坐标点
     * @returns {Number} 返回两点之间的测地距离。
     */
    getGeodesicDistance: function getGeodesicDistance(pointOne, pointTwo) {
      var _Cesium2 = Cesium,
          Ellipsoid = _Cesium2.Ellipsoid,
          EllipsoidGeodesic = _Cesium2.EllipsoidGeodesic;
      var pickedPointCartographic = Ellipsoid.WGS84.cartesianToCartographic(pointOne);
      var lastPointCartographic = Ellipsoid.WGS84.cartesianToCartographic(pointTwo);
      var geodesic = new EllipsoidGeodesic(pickedPointCartographic, lastPointCartographic);
      return geodesic.surfaceDistance;
    },
    clear: function clear() {
      this.polylines = [];
      this.measuring = false;
    }
  }
};

/* script */
var __vue_script__ = script;
/* template */

var __vue_render__ = function __vue_render__() {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('i', {
    class: _vm.$options.name,
    staticStyle: {
      "display": "none !important"
    }
  }, [_vm.arcType === 0 ? _c('vc-collection-primitive-polyline', {
    ref: "polylineCollection"
  }, _vm._l(_vm.polylines, function (polyline, index) {
    return _c('vc-primitive-polyline', {
      key: index,
      attrs: {
        "material": polyline.materialLine,
        "positions": polyline.positions,
        "width": _vm.polylineWidth
      }
    });
  }), 1) : _vm.arcType === 1 ? _c('vc-datasource-custom', {
    attrs: {
      "name": "vc-distance-measure"
    }
  }, _vm._l(_vm.polylines, function (polyline, index) {
    return _c('vc-entity', {
      key: index,
      attrs: {
        "description": _vm.$vc.lang.measure.distance + ': ' + (polyline.distance > 1000 ? (polyline.distance / 1000).toFixed(2) + 'km' : polyline.distance.toFixed(2) + 'm'),
        "id": _vm.$vc.lang.measure.distance + '-' + (index + 1)
      }
    }, [_c('vc-graphics-polyline', {
      attrs: {
        "material": _vm.polylineColor,
        "positions": polyline.positions,
        "width": _vm.polylineWidth
      },
      on: {
        "ready": _vm.ready
      }
    })], 1);
  }), 1) : _vm._e(), _vm._v(" "), _c('vc-collection-primitive-point', [_vm._l(_vm.polylines, function (polyline, index) {
    return [_vm._l(polyline.positions, function (position, subIndex) {
      return [_c('vc-primitive-point', {
        key: 'point' + index + 'position' + subIndex,
        attrs: {
          "color": _vm.pointColor,
          "pixelSize": _vm.pointPixelSize,
          "position": position
        }
      })];
    })];
  })], 2), _vm._v(" "), _c('vc-collection-primitive-label', {
    ref: "labelCollection"
  }, [_vm._l(_vm.polylines, function (polyline, index) {
    return [_vm._l(polyline.positions, function (position, subIndex) {
      return [polyline.distances[subIndex] !== 0 ? _c('vc-primitive-label', {
        key: 'label' + index + 'position' + subIndex,
        attrs: {
          "backgroundColor": _vm.backgroundColor,
          "fillColor": _vm.fillColor,
          "font": _vm.font,
          "horizontalOrigin": 1,
          "labelStyle": _vm.labelStyle,
          "outlineColor": _vm.outlineColor,
          "outlineWidth": _vm.outlineWidth,
          "pixelOffset": _vm.pixelOffset,
          "position": position,
          "showBackground": _vm.showBackground,
          "text": _vm.$vc.lang.measure.distance + ': ' + (polyline.distances[subIndex] > 1000 ? (polyline.distances[subIndex] / 1000).toFixed(2) + 'km' : polyline.distances[subIndex].toFixed(2) + 'm')
        }
      }) : _vm._e()];
    })];
  })], 2)], 1);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "VcMeasureDistance.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}
/* style inject */

/* style inject SSR */


var VcMeasureDistance = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

function plugin(Vue) {

  if (plugin.installed) {
    return;
  }

  plugin.installed = true;
  Vue.component(VcMeasureDistance.name, VcMeasureDistance);
}

export default plugin;
export { VcMeasureDistance, plugin as install };
